var e = {
	title: "Creator Portal",
	subTitle: "Your links and what they've produced",
	newLink: "New link",
	loadFailed: "Could not load your Creator Portal",
	offerHint: "Everyone who signs up through your links gets this.",
	sections: {
		overview: {
			label: "Overview",
			description: "What your links have produced"
		},
		links: {
			label: "Links",
			description: "One link for each place you post."
		},
		earnings: {
			label: "Earnings",
			description: "What you earned on the bookings you referred."
		},
		payoutMethods: {
			label: "Payout methods",
			description: "Where your commission gets paid."
		},
		socialLinks: {
			label: "Social links",
			description: "The public profiles on your creator application."
		}
	},
	socialLinks: {
		widgetTitle: "Your profiles",
		empty: "No profiles on file.",
		hint: "These are the profiles you listed when you applied. They help us match your audience to the right offer."
	},
	stats: {
		clicks: "Clicks",
		clicksHint: "Bots excluded",
		signups: "Signups",
		bookings: "Bookings"
	},
	links: {
		widgetTitle: "My links",
		empty: "No links yet. Create one for each place you post.",
		inactive: "Inactive",
		expiresOn: "Expires {{date}}",
		qr: "QR",
		qrTitle: "QR — {{code}}",
		qrHint: "Scans open your tracked link, so they're counted here too.",
		download: "Download PNG",
		share: "Share",
		shareTitle: "My Maat invite link",
		copied: "Link copied",
		copy: "Copy link",
		close: "Close",
		conversions: "Conversions",
		conversionsTitle: "Conversions — {{code}}",
		conversionsHint: "Every signup and booking this link produced.",
		conversionsEmpty: "Nothing from this link yet.",
		conversionsMore: "Load more",
		performanceTitle: "Link performance",
		performanceSubtitle: "What this link has produced.",
		chartTitle: "Clicks, signups and bookings",
		chartEmpty: "Nothing from this link in this period yet.",
		retentionNote: "Click history is kept for {{days}} days, so older clicks are not counted.",
		backToLinks: "All links",
		viewPerformance: "Performance",
		channelUnavailable: "Only channels on your creator profile are listed. Add a profile link to unlock more."
	},
	activity: {
		widgetTitle: "Recent activity",
		empty: "Nothing yet. Activity shows up here as people sign up and book.",
		chartTitle: "Clicks, signups and bookings",
		chartEmpty: "No activity in this period yet."
	},
	form: {
		title: "New link",
		channelLabel: "Where will you post this?",
		channelPlaceholder: "Pick a channel",
		campaignLabel: "Campaign label (optional)",
		campaignPlaceholder: "e.g. Summer reels",
		campaignHint: "Use this to tell two links on the same channel apart.",
		offerHint: "Your link carries your standard offer — you don't need to set one.",
		submit: "Create link",
		failed: "Could not create the link",
		createdTitle: "Link created",
		shareUrl: "Share this URL",
		createdHint: "A QR code for this link is available from your portal.",
		backToPortal: "Back to portal",
		validation: {
			channelRequired: "Pick a channel",
			campaignTooLong: "Keep the campaign label under 80 characters"
		},
		created: "Link created"
	},
	earnings: {
		title: "Earnings",
		subTitle: "What you earned on the bookings you referred.",
		loadFailed: "Could not load your earnings",
		pending: "Pending",
		pendingHint: "Clears when the stay begins",
		available: "Available",
		availableHint: "Ready to withdraw",
		paidOut: "Paid out",
		otherCurrencies: "Also available: {{list}}",
		widgetTitle: "Your commission",
		empty: "No commission yet. You earn on a referred guest's first booking.",
		bookingRef: "Booking {{ref}}",
		clearsOn: "Clears {{date}}",
		refunded: "Refunded",
		status: {
			PENDING: "Pending",
			AVAILABLE: "Available",
			PAYOUT_PENDING: "Withdrawing",
			PAID_OUT: "Paid"
		},
		loadMore: "Load more"
	},
	payouts: {
		request: "Withdraw",
		requestTitle: "Withdraw your commission",
		requestSubtitle: "Pick the commissions to withdraw. Each one is paid in full.",
		methods: "Payout methods",
		methodLabel: "Pay to",
		methodPlaceholder: "Select a payout method",
		noMethod: "Add a payout method before withdrawing",
		addMethod: "Add payout method",
		noneEligible: "Nothing is ready to withdraw yet",
		loadingCommissions: "Loading…",
		selectedCount: "{{count}} selected",
		submit: "Request withdrawal",
		requested: "Withdrawal requested",
		requestFailed: "Could not request the withdrawal",
		widgetTitle: "Withdrawals",
		empty: "No withdrawals yet",
		status: {
			REQUESTED: "Requested",
			PAID: "Paid",
			REJECTED: "Rejected",
			CANCELLED: "Cancelled"
		},
		loadMore: "Load more",
		receipts: "Receipts",
		receiptsTitle: "Transfer receipts",
		receiptsDescription: "Receipts are watermarked and open for 15 minutes at a time."
	},
	methods: {
		title: "Payout methods",
		subTitle: "Where your commission gets paid.",
		add: "Add method",
		empty: "No payout methods yet — add one to get paid",
		default: "Default",
		setDefault: "Set default",
		added: "Payout method added",
		removed: "Payout method removed",
		removeFailed: "Could not remove the method",
		saveFailed: "Could not save the method",
		removeTitle: "Remove this payout method?",
		removeDescription: "It will no longer be available for withdrawals. You can add it again later.",
		form: {
			title: "Add payout method",
			methodType: "Method type",
			methodBankTransfer: "Bank transfer",
			methodInstaPay: "InstaPay",
			methodWallet: "Wallet",
			label: "Label (optional)",
			labelPlaceholder: "e.g. My NBE account",
			accountHolder: "Account holder name",
			accountHolderPlaceholder: "Full name on the account",
			bankName: "Bank name",
			accountNumber: "Account number",
			iban: "IBAN (optional)",
			swift: "SWIFT / BIC (optional)",
			walletNumber: "Wallet number",
			setAsDefault: "Use this by default",
			submit: "Add method",
			validation: {
				accountHolderRequired: "Account holder is required",
				bankNameRequired: "Bank name is required",
				accountOrIbanRequired: "Account number or IBAN is required",
				walletRequired: "This field is required"
			}
		},
		cancel: "Cancel",
		remove: "Remove"
	},
	series: {
		clicks: "Clicks",
		signups: "Signups",
		bookings: "Bookings"
	}
};
//#endregion
export { e as default };
